export class TableScrollInitializer {
	init = () => {
		const technicalDataContainer = document.querySelector<HTMLDivElement>('.product-table-container');
		if (technicalDataContainer == null) return;

		const table = technicalDataContainer.querySelector<HTMLDivElement>('.table-scroll')!;

		const goLeft = technicalDataContainer.querySelector<HTMLButtonElement>('.go-left');
		const goRight = technicalDataContainer.querySelector<HTMLButtonElement>('.go-right');

		const row = technicalDataContainer.querySelector<HTMLDivElement>('.detail-overflow tr:nth-child(2)');
		const data = row?.querySelectorAll('td:not(.sticky)');

		if (data == null) return;

		goRight?.addEventListener('click', (e) => {
			e.preventDefault();

			table.scrollBy({ behavior: 'smooth', left: 452 });
		});

		goLeft?.addEventListener('click', (e) => {
			e.preventDefault();

			table.scrollBy({ behavior: 'smooth', left: -452 });
		});

		this.tableMove(table);
	};

	tableMove = (table: HTMLDivElement) => {
		let startX = 0;
		let scrollLeft = 0;
		let isDown = false;

		table.addEventListener('mousedown', (e) => {
			isDown = true;
			startX = e.pageX - table.offsetLeft;
			scrollLeft = table.scrollLeft;
		});

		table.addEventListener('mouseup', (e) => {
			isDown = false;
		});

		table.addEventListener('mouseleave', (e) => {
			isDown = false;
		});

		table.addEventListener('mousemove', (e) => {
			if (isDown) {
				const x = e.pageX - table.offsetLeft;
				const walkX = x - startX;
				table.scrollLeft = scrollLeft - walkX;
			}
		});
	};
}
